/**
 * 表具全生命周期管理模块（src/views/AllLifeCycleManagement）英文映射
 * 中文原文做 key，value 为英文译文；与其他 en/modules/*.js 由 src/i18n/index.js 自动合并
 * 术语：故障率=Fault Rate，维修=Repair，返厂=Return to Factory，报废=Scrap，
 *       轮检/周期检定=Routine/Periodic Inspection（与 meterManagement.js 保持一致用 Routine Inspection），表具=Meter，用水户=Customer
 */
export default {
  // ── 通用（复用全局词条，同 en-US.js）──
  '确定': 'OK',
  '取消': 'Cancel',
  '关闭': 'Close',
  '查询': 'Query',
  '重置': 'Reset',
  '新增': 'Add',
  '删除': 'Delete',
  '编辑': 'Edit',
  '详情': 'Details',
  '更多': 'More',
  '操作': 'Action',
  '导入': 'Import',
  '导出': 'Export',
  '导出文件': 'Export File',
  '下载模板': 'Download Template',
  '展开': 'Expand',
  '收起': 'Collapse',
  '折叠': 'Collapse',
  '新增成功': 'Added successfully',
  '编辑成功': 'Updated successfully',
  '确定删除吗?': 'Are you sure you want to delete?',
  '当前选择：': 'Currently selected:',
  '取消选择': 'Deselect',
  '选择': 'Select',
  '已激活': 'Activated',
  '未激活': 'Not Activated',
  '个': 'pcs',
  '只': 'pcs',
  '元': 'CNY',
  // ── 区域树 / 查询条件 ──
  '请输入区域名称': 'Please enter area name',
  '区域名称': 'Area Name',
  '表编号': 'Meter No.',
  '请输入表编号': 'Please enter meter No.',
  '输入表编号模糊查询': 'Enter meter no. to search',
  '用户编号': 'Customer No.',
  '请输入用户编号': 'Please enter customer No.',
  '查询起始时间': 'Start time',
  '查询结束时间': 'End time',
  '使用年限': 'Service Years',
  '请输入使用年限': 'Please enter service years',
  '检定结果': 'Inspection Result',
  '请选择检定结果': 'Please select inspection result',
  // ── 维修（Repair）──
  '维修类型': 'Repair Type',
  '请选择维修类型': 'Please select repair type',
  '请输入维修类型': 'Please enter repair type',
  '维修时间': 'Repair Time',
  '请选择维修时间': 'Please select repair time',
  '维修记录': 'Repair Records',
  '维修模板': 'Repair Template',
  '不换表': 'No Replacement',
  '处理描述': 'Handling Description',
  '请输入处理描述': 'Please enter handling description',
  '表故障率': 'Meter Fault Rate',
  '表维修率': 'Meter Repair Rate',
  '返厂数量': 'Return-to-Factory Quantity',
  '修复率': 'Repair Rate',
  '故障率趋势图': 'Fault Rate Trend Chart',
  // ── 返厂（Return to Factory）──
  '返厂状态': 'Return-to-Factory Status',
  '请选择返厂状态': 'Please select return-to-factory status',
  '返厂日期': 'Return-to-Factory Date',
  '请选择返厂日期': 'Please select return-to-factory date',
  '返厂原因': 'Return-to-Factory Reason',
  '请选择返厂原因': 'Please select return-to-factory reason',
  '请输入返厂原因': 'Please enter return-to-factory reason',
  '返厂原因描述': 'Return-to-Factory Reason Description',
  '请输入返厂原因描述': 'Please enter return-to-factory reason description',
  '返厂记录': 'Return-to-Factory Records',
  '返厂模板': 'Return-to-Factory Template',
  '完成日期': 'Completion Date',
  '请选择完成日期': 'Please select completion date',
  '安装数量': 'Installed Quantity',
  '表总数量': 'Total Meters',
  // ── 报废（Scrap）──
  '报废原因': 'Scrapping Reason',
  '请输入报废原因': 'Please enter scrapping reason',
  '报废时间': 'Scrapping Time',
  '请选择报废时间': 'Please select scrapping time',
  '报废日期': 'Scrapping Date',
  '报废描述': 'Scrapping Description',
  '请输入报废描述': 'Please enter scrapping description',
  '报废记录': 'Scrapping Records',
  '报废模板': 'Scrapping Template',
  '已报废数量': 'Scrapped Quantity',
  '该数据来自表具明细的统计': 'This data is aggregated from meter details',
  // ── 轮检（Routine Inspection）──
  '当前轮检': 'Current Routine Inspection',
  '轮检记录': 'Routine Inspection Records',
  '轮检模板': 'Routine Inspection Template',
  '轮检数量': 'Routine Inspection Count',
  '更新检定': 'Update Inspection',
  '检定日期': 'Inspection Date',
  '请选择检定日期': 'Please select inspection date',
  '到检日期': 'Next Inspection Date',
  '请选择到检日期': 'Please select next inspection date',
  '请输入到检日期': 'Please enter next inspection date',
  '出厂日期': 'Production Date',
  '请输入出厂日期': 'Please enter production date',
  '在库表具数量': 'Meters in Stock',
  '超期表数量': 'Overdue Inspection Meters',
  '操作员': 'Operator',
  '请选择操作员': 'Please select operator',
  '请选择表编号': 'Please select meter no.',
  // ── 表头 ──
  '表口径': 'Meter Caliber',
  '表类型': 'Meter Type',
  '表状态': 'Meter Status',
  '用户状态': 'Customer Status',
  '用户姓名': 'Customer Name',
  '用户地址': 'Customer Address',
  '当前余额(元)': 'Current Balance (CNY)',
  '添加时间': 'Added At',
  // ── 选择表具弹窗 ──
  '选择表具': 'Select Meter',
}
